module.exports = __webpack_public_path__ + "static/media/forward.103af5a9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/shared/routes/components/calendar/forward.svg
// module id = 468
// module chunks = 0